import { useState } from "react";
import { FiX } from "react-icons/fi";
import { SelectPop } from "../../../../../../components/forms/selects/SelectPop";
import { SelectOdc } from "../../../../../../components/forms/selects/SelectOdc";
import { BtnDefault } from "../../../../../../components/buttons/BtnDefault";
import { SelectOdp } from "../../../../../../components/forms/selects/SelectOdp";

export const InfrastucturUpdate = ({ data, open, setOpen, refreshData }) => {
  const [loading, setLoading] = useState(false);

  const initialFormState = {
    pop_id: "",
    odc_id: "",
    name: "",
    port: 4,
    description: "",
  };

  const [formData, setFormData] = useState(initialFormState);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Perbaikan: Menggunakan OdpService untuk membuat ODP
    //   await OdpService.create({ data: formData });
    //   refreshData();
    //   setOpen(false);
      // Perbaikan: Mengembalikan form ke state kosong yang benar
      setFormData(initialFormState);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-slate-800 w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h3 className="text-lg font-bold text-white">Update Infrastruktur</h3>
          <button
            onClick={() => setOpen(false)}
            className="p-2 hover:bg-white/10 rounded-full transition-colors"
          >
            <FiX size={20} className="text-white" />
          </button>
        </div>

        {/* Body Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4 max-h-[80vh] overflow-y-auto custom-scrollbar">

          {/* Perbaikan: Menggabungkan state agar tidak saling menimpa */}
          <SelectPop
            label={"Server POP"}
            value={formData.pop_id} 
            setValue={(pop_id) => {
              setFormData({ 
                ...formData, 
                pop_id: pop_id, 
                odc_id: "" 
              });
            }} 
          />

          <SelectOdc
            pop_id={formData.pop_id}
            value={formData.odc_id} 
            setValue={(id) => {
              setFormData({ ...formData, odc_id: id });
            }}
            disabled={formData.pop_id === ""}
          />

          <SelectOdp
            pop_id={formData.pop_id}
            value={formData.odc_id} 
            setValue={(id) => {
              setFormData({ ...formData, odc_id: id });
            }}
            disabled={formData.pop_id === ""}
          />

          {/* Action Buttons */}
          <div className="flex gap-3 pt-4 border-t border-white/10">
            <button
              type="button"
              disabled={loading}
              onClick={() => setOpen(false)}
              className="flex-1 px-4 py-2.5 border border-white text-white rounded-xl font-semibold hover:bg-white/10 transition-all text-sm disabled:opacity-50"
            >
              Batal
            </button>
            <BtnDefault
              type="submit"
              disabled={loading}
              className="flex-1 justify-center py-2.5"
            >
              {loading ? "Sedang Menyimpan..." : "Simpan"}
            </BtnDefault>
          </div>
        </form>
      </div>
    </div>
  );
};